import React, { useRef, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Loader from "./../../components/Loader/Loader";
import HeaderOne from "../../components/Header/HeaderOne";
import AboutArchitecture from "../../components/AboutUs/AboutArchitecture";
import FunFactsArchitecture3 from "../../components/FunFacts/FunFactsArchitecture3";
import Gallery from "../../components/Gallery/Gallery";
import ContactArchitecture from "../../components/ContactUs/ContactArchitecture";
import FooterOne from "../../components/Footer/FooterOne";

import CTAOne from "../../components/CTA/CTAOne";


const paragraph2 = (
  <>
    {`Here's How ${new Date().getFullYear()} Is Adding Up So Far:`}
    <br />
    {`YTD Average Price Comparison of All Property Types`}
  </>
);

const Architecture = () => {
  const home = useRef();
  const about = useRef();
  const sales = useRef();
  const service = useRef();
  const agents = useRef(); 
  const rentals = useRef();
  const contact = useRef();

  

  function scrollToSection(e, content) {
    e.preventDefault();
    switch (content) {
      case "home":
        home.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "about":
        about.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "sales":
        sales.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "service":
        service.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "agents":
        agents.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "rentals":
        rentals.current.scrollIntoView({ behavior: "smooth" });
        break;
      case "contact":
        contact.current.scrollIntoView({ behavior: "smooth" });
        break;
      default:
    }
  }

  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  return (
      <Loader>
        <HeaderOne scrollToSection={scrollToSection} />

        <AboutArchitecture   ref={about} classAppend="mt-50" />

        <section className=" mt-minus-50">
          <div className="container mt-0 col-md-12">

  <h3>THE COMPANY</h3>
  Olshan Realty Inc. was founded in 1980 and is one of New York’s leading boutique residential brokerage firms, specializing in residential sales, rentals, corporate relocation, investments and property management. The firm prides itself on a high level of service that employs technology, research, and data analytics. Olshan Realty was the first company in Manhattan to have a corporate relocation department and has represented Fortune 500 relocating executives from Goldman Sachs, Credit-Suisse, Deutsch Bank, Mercedes Benz, DuPont, Mobil, Exxon and Citicorp, among others.

  <h3>AGENTS</h3>
  Olshan Realty Inc. has some of the most experienced agents in the business. The average Olshan agent has over 25 years of experience and works as a team. Agents are equipped to handle all kinds of properties, areas, price ranges and needs. All are members of the Real Estate Board of New York (REBNY), which has over 15,000 members. Some Olshan agents belong to the Hudson Gateway Association of Realtors and the OneKey Multiple Listing Service (MLS), which has 45,000 members and covers Westchester, Long Island, Rockland, Putnam, Dutchess, Orange, Ulster and Sullivan Counties.

  <h3>PROPERTY MANAGEMENT</h3>
  Olshan Realty Inc. has a property management division that is overseen by award-winning property manager, Jennifer Stutz, who is considered one of the finest in the country. Jennifer handles the properties of investors and relocating executives while overseeing a portfolio ranging from apartments to townhouses throughout New York City. Services include overseeing payment of monthly homeowner fees, arranging for repairs, dealing with vendors for absentee owners and serving as a liaison between owners, tenants, homeowner associations and managing agents.

  <h3>CORPORATE RELOCATION</h3>
  When it comes to relocating executives, companies often turn to corporate relocation experts to help buy, sell and rent residential real estate for their employees. Olshan Realty Inc has the premier relocation department and is the top choice of America’s relocation companies. Since 1980, Olshan has handled hundreds of millions of doillars in transactions, representing such companies as Dwellworks, Cartus, Brookfield Global Relocation, Prudential Relocation, Relocation Resources, Mobility Services International, Associates Relocation and Royal LePage, among others. Our staff is equipped to handle the brokerage, rental and property management. Olshan serves customers in all price ranges. The company’s database accesses thousands of sales and rental listings across New York City.

  <h3>MARKETING DEPARTMENT</h3>
  Here’s what you can expect from the Olshan Marketing Department:

  <ul>
      <li><strong>BROCHURES: </strong>Each property has a brochure designed with photos, text, floorplans and sometimes alternate floorplans are designed. Brochures also feature building amenities, neighborhood information and pertinent building data. </li>

      <li><strong>MULTIPLE LISTING SERVICE: </strong>Olshan Realty belongs to two MLSes: The Real Estate Board of New York (REBNY) and its RLS service have over 15,000 members. It also belongs to OneKey MLS, which has 45,000 members and covers NYC, Westchester, Long Island, Rockland, Putnam, Dutchess, Orange, Ulster and Sullivan Counties. Together, these MLSes power the distribution of thousands of listings, totaling billions of dollars in real estate, to 60,000 agents.  </li>

      <li><strong>WEB: </strong>Olshan listings are displayed on Olshan.com, Streeteasy, Zillow, Realtor.com, Trulia.com Homes.com, OneKey.com and OLR.com, among over 350 websites. </li>

      <li><strong>SOCIAL MEDIA: </strong>Olshan uses Facebook, Instagram and Reels to facilitate marketing. </li>


      <li><strong>INTERNET and DOMAIN STRATEGY: </strong>Since 1995, when Donna Olshan realized the power of the internet, the company has been an active purchaser of real estate domain names. Olshan owns the following domain names, which help drive traffic to Olshan.com: townhouse.com, co-ops.com, nyrealestate.com, nybroker.com, nyhomes.com and nylofts.com, among others. Olshan also owns a portfolio of domain names to many residential addresses that point to their exclusive property listings. </li>
  </ul>

  <h3>OLSHAN LUXURY REPORT</h3>
Olshan is in the news each week with the <strong>Olshan Luxury Report</strong>, published every Monday morning at 7:15AM. It is frequently quoted in the <i>New York Times, Wall Street Journal, Bloomberg, The Real Deal, Crain’s, Politico, Architectural Digest</i> and various media outlets. The weekly report covers all the contracts signed in Manhattan at $4 million and above.  It is considered an industry must read, the go-to resource for buyers, sellers, developers, banks, hedge funds, and various institutions looking for a pulse on the Manhattan luxury market. It has a global list of subscribers.


  </div>
  </section>
        
  <FunFactsArchitecture3
                
                title={new Date().getFullYear()}
                tagline="By The Numbers"
                paragraph1="In 2024 the average asking price in the luxury sector ($4 million and above) was 4%
                higher than 2023. Once again, condos outsold co-ops more than 3-to-1, reflecting an ongoing trend: The
                average luxury buyer wants the freedom of condo ownership, new construction, and a
                robust menu of amenities. Townhouse sales were flat."
                paragraph2={paragraph2}  paragraph3={`FOR PROPERTIES $4 MILLION AND ABOVE`} paragraph4={<div dangerouslySetInnerHTML={{ __html: 'Data sourced from The Olshan Realty <a class="underline" href="/market-report">Luxury Market Report</a>.' }} />}
              />
              

        <Gallery
          title="MORE FEATURED PROPERTIES"
          tagline="Currently ON MARKET"
          classAppend="mt-150"
          ref={sales}
        />

      

        <ContactArchitecture
          title="CONTACT OLSHAN"
          tagline="Connect to Your New Home"
          classAppend="mt-50"
          ref={contact}
        />

  <CTAOne
          tagline="Olshan Luxury Report"
          title="Highly focused. Data Driven."
          textButton="GET THE LATEST LUXURY REPORT"
          linkButton="/market-report"
          bg="color"
        >
          This report is the only one of its kind. On a weekly basis, Olshan publishes a report covering all the contract activity in the luxury market on properties at $4 million and above. The free report draws subscribers from all over the world, and is frequently quoted in the New York Times, Wall Street Journal, Crain's, Observer, The Real Deal and various media outlets. 
        </CTAOne>
        <FooterOne />
      </Loader>
  );
};



export default Architecture;
